import { Box, Flex, Text, VStack } from '@chakra-ui/react'
import { Info } from '@phosphor-icons/react'
import Indicator from './Indicator'

const IndicatorEvent = () => {
	return (
		<Box w="full">
			<Flex>
				<Box>
					<Box mb="12px">
						<Text fontSize="md" fontWeight="bold">Colhido em 01/01/2024 às 15:00:00</Text>
					</Box>
					<VStack spacing={4}>
						<Indicator title="Hospitalização: Não, nenhuma vez" />
						<Indicator title="Hospitalização: Não, nenhuma vez" />
						<Indicator title="Hospitalização: Não, nenhuma vez" />
					</VStack>
				</Box>
			</Flex>
		</Box>
	)
}

export default IndicatorEvent
